import { Reveal, Overline } from "@/components/Motion";
import { INSTAGRAM_TILES } from "@/data/content";

const Instagram = () => (
  <section className="py-28 sm:py-36" data-testid="instagram-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="flex flex-wrap items-end justify-between gap-8 mb-14">
        <div>
          <Reveal>
            <Overline className="text-wine">@forco_amore</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-5">
              Follow the <span className="italic text-wine">Amore</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <a
            href="https://instagram.com/forco_amore"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-btn"
            className="rounded-full border border-wine px-8 py-3.5 text-sm tracking-[0.14em] uppercase text-wine hover:bg-wine hover:text-cream transition-colors duration-300"
          >
            Follow Us
          </a>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {INSTAGRAM_TILES.map((src, i) => (
          <Reveal key={src} delay={i * 0.07} y={30}>
            <a
              href="https://instagram.com/forco_amore"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block overflow-hidden rounded-2xl aspect-square"
              data-testid={`instagram-tile-${i}`}
              aria-label={`Instagram photo ${i + 1}`}
            >
              <img src={src} alt={`Forco Amore on Instagram — photo ${i + 1}`} loading="lazy" className="img-lux h-full w-full object-cover" />
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Instagram;
